import { Link } from "react-router-dom";

import { Ecr } from "api/memberPortal/ecr/ecr.types";

const EcrVidCell = ({ ecr }: { ecr: Ecr }) => {
  if (!ecr.pid) return;

  return (
    <Link
      to={`/community/products/details/${ecr.pid.product_id}`}
      className="text-decoration-underline"
    >
      {ecr.pid.v_id}
    </Link>
  );
};

export default EcrVidCell;
